import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { debounce } from 'lodash';
import React, { ReactNode, useRef, useState } from 'react';
import styled from 'styled-components';
import Swiper from 'swiper/types/swiper-class';

interface Props {
  swiper: Swiper | undefined;
  className?: string;
  setImageSelected?: (index: number) => void;
  imageSelected?: number;
  children?: ReactNode;
  length?: number;
  black?: boolean;
}

export const CarouselControls: React.FC<Props> = ({
  swiper,
  children,
  black = false,
  imageSelected = 0,
  setImageSelected,
  length = 0,
}) => {
  const [deb, setDeb] = useState<boolean>(true);
  const debouncedClick = useRef(debounce(() => setDeb(true), 450)).current;

  React.useEffect(() => {
    return () => {
      debouncedClick.cancel();
    };
  }, [debouncedClick]);

  const [, setActiveIndex] = useState(0);
  swiper?.on('slideChange', () => setActiveIndex(swiper.activeIndex));

  return (
    <Container $black={black}>
      {length > 3 && (
        <>
          <ControlDiv>
            <ClickableZone
              onClick={() => {
                if (deb === true) {
                  setDeb(false);
                  swiper?.slidePrev();
                  imageSelected <= 0
                    ? setImageSelected?.(length - 1)
                    : setImageSelected?.(imageSelected - 1);

                  debouncedClick();
                }
              }}
            />
            <FontAwesomeIcon icon={faChevronLeft} size={'lg'} />
          </ControlDiv>
          {children}
          <ControlDiv>
            <ClickableZone
              onClick={() => {
                if (deb === true) {
                  setDeb(false);
                  swiper?.slideNext();
                  imageSelected >= length - 1
                    ? setImageSelected?.(0)
                    : setImageSelected?.(imageSelected + 1);
                  debouncedClick();
                }
              }}
            />
            <FontAwesomeIcon icon={faChevronRight} size={'lg'} />
          </ControlDiv>
        </>
      )}
    </Container>
  );
};

const Container = styled.div<{ $black: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.6rem;
  font-size: 0.5rem;
  color: ${({ theme, $black }) =>
    $black ? theme.colors.black : theme.colors.white};
`;

const ControlDiv = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  position: relative;
  transition: opacity 0.2s;
`;

const ClickableZone = styled.div`
  content: '';
  position: absolute;
  top: -10px;
  right: -10px;
  bottom: -10px;
  left: -10px;
`;
